import React from 'react';
import { PapiDeviationPoll } from '@wix/da-papi-types';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Poll';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import pollStyles from './Poll.scss';

export interface Props {
  poll: PapiDeviationPoll;
}

const VotableAnswers: React.FC<Props> = ({ poll }) => {
  return (
    <ul className={pollStyles['answers']}>
      {poll.answers.map(({ answerId, image, textContent }) => (
        <li key={`answer:${answerId}`} className={pollStyles['answer']}>
          <div className={pollStyles['answer-row']}>
            {image && (
              <MinimalDumbo
                className={pollStyles['pollimage']}
                deviation={image}
                width={72}
                height={72}
              />
            )}
            <TextRenderer
              htmlExcerptLegacy
              isPollWithHtmlExcerpt
              className={classnames(
                pollStyles['answer-text'],
                'da-editor-poll-thumb'
              )}
              textContent={textContent}
              viewerKey={answerId}
              tipTapViewer={PollTiptapViewer}
              cookieType={MeasuredCookieType.EDITOR_POLL}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default VotableAnswers;
